import { Box, Divider } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import ArchetypetoUMIPanel from './ArchetypetoUMIPanel'
import DeleteProjectWidget from './DeleteProjectWidget'
import GISPanel from './GISPanel'
import ProjectHeader from './ProjectHeader'
import ScenarioOverview from './ScenarioOverview'

///// Hooks
const useStyles = makeStyles(() => ({
  divider: {
    marginTop: '1rem',
    marginBottom: '1rem',
  },
}))

///// Components
const Dashboard: React.FC = () => {
  const classes = useStyles()
  return (
    <Box>
      <ProjectHeader />
      <Divider className={classes.divider} />
      <GISPanel />
      <Divider className={classes.divider} />
      <ArchetypetoUMIPanel />
      <ScenarioOverview />
      <Divider className={classes.divider} />
      <DeleteProjectWidget />
    </Box>
  )
}

export default Dashboard
